import http from "@/api/http";
import cookie from "@/plugins/cookie";

const PBX_TOKEN_COOKIE = "PBX_TOKEN";
const ORGANIZATION_ID = "ORGANIZATION_ID";
const ORGANIZATION_NAME = "PBX_ORGANIZATION_NAME";

const state = {
  pbxToken: cookie.getCookie(PBX_TOKEN_COOKIE) ?? null,
  organizationId: parseInt(cookie.getCookie(ORGANIZATION_ID)) ?? null,
  organizationName: cookie.getCookie(ORGANIZATION_NAME) ?? "",
  organization: null,
  organizations: []
}

const getters = {
  getOrganizations: (state) => state.organizations,
  getOrganization: (state) => state.organization,
  getPbxToken: (state) => state.pbxToken,
  getOrganizationId: (state) => state.organizationId,
  getOrganizationName: (state) => state.organizationName,
}

const mutations = {
  SET_PBX_TOKEN: (state, value) => state.pbxToken = value,
  SET_ORGANIZATION_ID: (state, value) => {
    state.organizationId = value
    cookie.setCookie(ORGANIZATION_ID, value, 12);
  },
  SET_ORGANIZATION_NAME: (state, value) => {
    state.organizationName = value
    if (value) {
      cookie.setCookie(ORGANIZATION_NAME, value, 12);
    } else {
      cookie.removeCookie(ORGANIZATION_NAME);
    }

  },
  SET_ORGANIZATION: (state, value) => {
    state.organization = value
  },
  SET_ORGANIZATIONS: (state, value) => state.organizations = value
}

const actions = {
  async doLoginPbx({commit, getters}) {
    const id = getters.getOrganizationId;
    const { data } =  await http.post(`/pbx/${id}/auth`);
    if (data.status) {
      commit("SET_PBX_TOKEN", data.token);
      cookie.setCookie(PBX_TOKEN_COOKIE, data.token, 12);
    }
  },
  async fetchOrganizations({ commit }) {
    const { data = { ['hydra:member'] : [] } } = await http.get('organizations/manage', { params: { pagination: false }})
    commit('SET_ORGANIZATIONS', data['hydra:member'])
  }
}

export default {
  namespaced : true,
  state,
  getters,
  mutations,
  actions
}
